import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconUserPlaceholder: React.FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4"
      stroke="none"
      fill="currentColor"
    />
  </SvgIcon>
)

